import newsCommon from './news.common';

const { media, official, ALL } = newsCommon;

ALL.forEach((ele) => {
    ele.getContent = () => import(`./news/${ele.id}.html`);
});

export {
    media, official
}

export const getById = (id) => {
    return ALL.filter(ele => ele.id === id)[0];
}

export default newsCommon;



// WEBPACK FOOTER //
// ./src/data/news.js